import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CfgService } from '../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class NotificationHubCfg {
  public getByIdentityEndpoint: string;
  public updateFilterConfigurationEndpoint: string;
  public queryFilterConfigurationEndpoint: string;
  public getApplicationIdentitiesEndpoint: string;
  public getApplicationIdentityTreeEndpoint: string;
  public createApplicationIdentityEndpoint: string;
  public deleteApplicationIdentityEndpoint: string;
  public sendNotificationEndpoint: string;
  public uploadAttachmentEndpoint: string;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationHubCfgService extends CfgService<NotificationHubCfg> {
  json: any = {
    getByIdentityEndpoint: "%{NotificationHubApi}/notification",
    updateFilterConfigurationEndpoint: "%{NotificationHubApi}/filter/{0}/configuration",
    queryFilterConfigurationEndpoint: "%{NotificationHubApi}/filter/{0}/configuration/query",
    getApplicationIdentitiesEndpoint: "%{NotificationHubApi}/applicationidentity/plain",
    getApplicationIdentityTreeEndpoint: "%{NotificationHubApi}/applicationidentity/tree",
    createApplicationIdentityEndpoint: "%{NotificationHubApi}/applicationidentity",
    deleteApplicationIdentityEndpoint: "%{NotificationHubApi}/applicationidentity",
    sendNotificationEndpoint: "%{NotificationHubApi}/notification",
    uploadAttachmentEndpoint: "%{NotificationHubApi}/attachment"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/notification/notificationHub.cfg.json`;
  }

  /**
* Carga las url en el json
*/
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
